export default "__VITE_ASSET__C$WbzA36__"